<script lang="ts">
	import Header from './Header.svelte';
	import Form from './Form.svelte';
	import Footer from './Footer.svelte';
</script>

<section class="bg-gray">
  <div class="container-fluid p-0">
    <div class="row no-gutters">
      <div class="col-xl-4 col-lg-5 align-self-end">
      </div>
      <div class="col-xl-8 col-lg-7">
        <div class="row feature-blocks bg-gray justify-content-between" id="informacje">
          
          <div class="col-sm-6 col-xl-5 mb-xl-5 mb-lg-3 mb-4 text-center text-sm-left">
            <i class="ti-write mb-xl-4 mb-lg-3 mb-4 feature-icon"></i>
            <h3 class="mb-xl-4 mb-lg-3 mb-4">Darmowy newsletter</h3>
            <p>Zapisz się do naszego newslettera aby otrzymywać wprost na skrzynkę mailową nowości na interesującej stronie BIP.</p>
          </div>
          
          <div class="col-sm-6 col-xl-5 mb-xl-5 mb-lg-3 mb-4 text-center text-sm-left">
            <i class="ti-blackboard mb-xl-4 mb-lg-3 mb-4 feature-icon"></i>
            <h3 class="mb-xl-4 mb-lg-3 mb-4">Bezpieczeństwo</h3>
            <p>Przekazane przez Ciebie dane zostaną wykorzystane tylko i wyłącznie w celu zapewnienia usługi newslettera.</p>
          </div>
          
        </div>
      </div>
    </div>
  </div>
</section>

<section class="section section-small bg-primary">
  <div class="container">
    <div class="row">
      <div class="col-12 text-center">
        <h6 class="text-white font-secondary mb-0">Podaj swój e-mail oraz adres strony której aktualności chcesz śledzić</h6>
        <h2 class="section-title text-white">Zapisz się na newsletter:</h2>
      </div>
    </div>
  </div>
</section>

<Form />

<Footer />
